import { OfferRequest } from "../models/OfferRequest";
import { Insured } from "../models/Insured";
import { ScoreRequest } from "../models/ScoreRequest";

import bus from "./bus.js";

export default function requestOffers(vue, productAlreadySelected=false){

    const offerRequest = new OfferRequest();

    if(vue.$store.state.site==="cibc"){
      offerRequest.Configuration.ClientCode="CIBC";
    }
    else {
      offerRequest.Configuration.ClientCode="CIBCIndividual";
    }

    offerRequest.Coverage.PurchaseDate = vue.$moment().format("YYYY-MM-DD");
    offerRequest.Coverage.PricingDate = vue.$moment().format("YYYY-MM-DD");
    // Helper: safely format date or return empty string if invalid
    const safeFormat = (value) => {
      const m = vue.$moment(value, ["MM/DD/YYYY","M/D/YYYY"], true);
      return m.isValid() ? m.format("YYYY-MM-DD") : "";
    };
    const getDatepickerDomValue = (fieldId) => {
      const root = document.getElementById(fieldId) || null;
      const input = root && typeof root.querySelector === "function" ? root.querySelector("input.dp__input") : null;
      if (input && typeof input.value === "string") {
        return input.value;
      }
      if (root && typeof root.value === "string") {
        return root.value;
      }
      return "";
    };
    const safeDob = (value) => safeFormat(value);
    const getTravellerDob = (index) => {
      if (vue.$route.name === "TravelPlans") {
        return vue.$store.state.oldestTraveller_dob || getDatepickerDomValue("oldestTraveller_dob");
      }
      const stateValue = vue.$store.state[`traveller${index}_dob`];
      if (stateValue) {
        return stateValue;
      }
      return getDatepickerDomValue(`traveller${index}_dob`);
    };

    if(vue.$route.name==="TravelPlans"){
      const depDom = getDatepickerDomValue("departureDate");
      const retDom = getDatepickerDomValue("returnDate");
      const provDom = document.getElementById("province")?.value || "";
      const depSrc = vue.$store.state.departureDate || depDom;
      const retSrc = vue.$store.state.returnDate || retDom;
      offerRequest.Coverage.StartDate = safeFormat(depSrc);
      offerRequest.Coverage.EndDate = safeFormat(retSrc);
      offerRequest.Coverage.ProvinceOfResidence = provDom || vue.$store.state.province || "";
    }
    else {
      offerRequest.Coverage.StartDate = safeFormat(vue.$store.state.departureDate);
      offerRequest.Coverage.EndDate = safeFormat(vue.$store.state.returnDate);
      offerRequest.Coverage.ProvinceOfResidence = vue.$store.state.province;
    }
    
    let numberOfTravellers;
    if(vue.$route.name==="TravelPlans"){
      const domValue = document.getElementById('numberOfTravellers')?.value;
      numberOfTravellers = parseInt(domValue || vue.$store.state.numberOfTravellers || "0", 10);
    } else {
      numberOfTravellers = parseInt(vue.$store.state.numberOfTravellers || "0", 10);
    }
    for(let i=1; i<=10;i++){
      if(i<=numberOfTravellers){
        const traveller = new Insured;

        const dobSource = getTravellerDob(i);
        traveller.DateOfBirth = safeDob(dobSource);

        if(vue.$route.name==="TravelPlans"){
          if(document.getElementById("tripCost").value===""){
            traveller.CoverageAmount= "0";
          }
          else {
            traveller.CoverageAmount= document.getElementById("tripCost").value;
          }
        } else {
          if(vue.$store.state.tripCost===""){
            traveller.CoverageAmount= "0";
          }
          else {
            traveller.CoverageAmount= vue.$store.state.tripCost;
          }
        }

        if(i===1) {
          traveller.IsPrimaryInsured=true;
          offerRequest.Coverage.Insured = [traveller];
        }
        else {
          traveller.IsPrimaryInsured=false;
          offerRequest.Coverage.Insured.push(traveller);
        }
      }
    }

    vue.isLoading=true;
    vue.$store.commit("setOfferRequest", offerRequest);
    // If Questionnnaire has just been filled out, send the survey answers
    if(vue.$route.name==="Questionnaire3") {
      const scoreRequest = new ScoreRequest();
      scoreRequest.Answers = [
        {
          "QuestionId": "q1-1",
          "Response": "true"
        },
        {
          "QuestionId": "q2-1a",
          "Response": String(vue.$store.state.medicalQuestion2)
        },
        {
          "QuestionId": "q2-1b",
          "Response": String(vue.$store.state.medicalQuestion3)
        },
        {
          "QuestionId": "q2-1c",
          "Response": String(vue.$store.state.medicalQuestion4)
        },
        {
          "QuestionId": "q2-1d",
          "Response": String(vue.$store.state.medicalQuestion5)
        },
        {
          "QuestionId": "q2-1e",
          "Response": String(vue.$store.state.medicalQuestion6)
        },
        {
          "QuestionId": "q2-1f",
          "Response": String(vue.$store.state.medicalQuestion7)
        },
        {
          "QuestionId": "q2-2a",
          "Response": String(vue.$store.state.medicalQuestion8)
        },
        {
          "QuestionId": "q2-2b",
          "Response": String(vue.$store.state.medicalQuestion9)
        },
        {
          "QuestionId": "q2-2c",
          "Response": String(vue.$store.state.medicalQuestion10)
        },
        {
          "QuestionId": "q2-3",
          "Response": String(vue.$store.state.medicalQuestion11)
        },
        {
          "QuestionId": "q2-4",
          "Response": String(document.getElementById("mq12y").checked)
        },
        {
          "QuestionId": "q2-5a",
          "Response": String(document.getElementById("mq13y").checked)
        },
        {
          "QuestionId": "q2-5b",
          "Response": String(document.getElementById("mq14y").checked)
        },
        {
          "QuestionId": "q2-5c",
          "Response": String(document.getElementById("mq15y").checked)
        },
        {
          "QuestionId": "q2-5d",
          "Response": String(document.getElementById("mq16y").checked)
        },
        {
          "QuestionId": "q2-5e",
          "Response": String(document.getElementById("mq17y").checked)
        },
        {
          "QuestionId": "q2-5f",
          "Response": String(document.getElementById("mq18y").checked)
        },
        {
          "QuestionId": "q2-5g",
          "Response": String(document.getElementById("mq19y").checked)
        },
        {
          "QuestionId": "q2-5h",
          "Response": String(document.getElementById("mq20y").checked)
        },
        {
          "QuestionId": "q2-5i",
          "Response": String(document.getElementById("mq21y").checked)
        },
        {
          "QuestionId": "q2-5j",
          "Response": String(document.getElementById("mq22y").checked)
        },
        {
          "QuestionId": "q2-5k",
          "Response": String(document.getElementById("mq23y").checked)
        },
        {
          "QuestionId": "q2-5l",
          "Response": String(document.getElementById("mq24y").checked)
        },
        {
          "QuestionId": "q3-1",
          "Response": String(document.getElementById("mq25y").checked)
        }
      ];
      vue.$store.commit("setAnswers", scoreRequest.Answers);
      scoreRequest.getScore(
        function callbackChangeStep(status, responseText) {
          if(status===200){
            if(responseText.Result==="Pass"){
              bus.$emit("sendOfferRequest", responseText);
            }
            else {
              bus.$emit("APIError","RWEC0022");
            }
          }
          else {
            bus.$emit("APIError","RWEC0021");
          }
          bus.$emit("hideLoading");
        });
    }
    else {
      bus.$emit("sendOfferRequest");
    }
}